import { useEffect, useState } from "react";

export function usePreloadImageManifest(manifestUrl: string) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let isCancelled: boolean = false;

    fetch(manifestUrl)
      .then((res) => res.json())
      .then((imageUrls: string[]) => {
        if (imageUrls.length === 0) {
          setLoaded(true);
          return;
        }

        let loadedCount: number = 0;

        const handleImageEvent = () => {
          loadedCount++;
          const allLoaded = loadedCount === imageUrls.length;
          if (allLoaded && !isCancelled) {
            setLoaded(true);
          }
        };

        const loadImage = (src: string) => {
          const img = new Image();
          img.onload = handleImageEvent;
          img.onerror = handleImageEvent;
          img.src = src;
        };

        imageUrls.forEach(loadImage);
      })
      .catch(() => setLoaded(true));

    return () => {
      isCancelled = true;
    };
  }, [manifestUrl]);

  return loaded;
}
